This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div v-if="isRunning || isPSD" class="col-span-1">
    <VariableBlock v-if="isRunning" :variables="variables" />
    <InstructionBlock
      v-if="!isRunning && isPSD"
      ref="instructionBlock"
      @updateContainers="$emit('updateContainers')"
    />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import VariableBlock from "@/components/game/psd/VariableBlock.vue";
import InstructionBlock from "@/components/game/psd/InstructionBlock.vue";
import * as types from "@/utils/Types";

@Options({
  props: {
    isPSD: Boolean,
    isRunning: Boolean,
    variables: [],
  },
  components: {
    VariableBlock,
    InstructionBlock,
  },
  methods: {
    passOnVariableCreation(
      varType: string,
      varName: string,
      optionsList: types.option[]
    ) {
      this.$refs.instructionBlock.addVariable(varType, varName, optionsList);
    },
  },
})
export default class SideBar extends Vue {}
</script>
